module.exports = __webpack_public_path__ + "img/넙죽이-05.31f058fe.png";